export default __webpack_public_path__ + "static/media/plan_chapter_view.60515b8b.png";